// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../microservices/dash/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".discussion-actions .action-buttons span{-webkit-user-select:none;-moz-user-select:none;user-select:none}.discussion-actions .action-buttons span:not(:first-of-type){margin-left:4px}.discussion-actions .action-buttons span.disabled-action{opacity:.6;pointer-events:none}", ""]);
// Exports
module.exports = exports;
